module.exports = __webpack_public_path__ + "img/iPhone13Pro.2b818995.png";